const { PUBLIC_URL = '', REACT_APP_API_URL = 'http://localhost:3037', REACT_APP_TRADE_IN_SOURCE = '' } = process.env;

export const config = {
  tradeInSource: REACT_APP_TRADE_IN_SOURCE,
  publicUrl: PUBLIC_URL,
  apiUrl: REACT_APP_API_URL,
};
